import { apiClient } from "./client";
import {
  CampaignCreate,
  CampaignCreateResponse,
  CampaignUpdate,
  CampaignStartResponse,
  CampaignStopResponse,
  ResidentLink,
  ResidentResponse,
  CampaignStats,
  CampaignListItem,
} from "../types";

export const campaignsApi = {
  createCampaign: async (campaign: CampaignCreate): Promise<CampaignCreateResponse> => {
    const response = await apiClient.post<CampaignCreateResponse>("/campaign/", campaign);
    return response.data;
  },

  updateCampaign: async (
    campaignId: number,
    campaign: CampaignUpdate
  ): Promise<CampaignCreateResponse> => {
    const response = await apiClient.put<CampaignCreateResponse>(
      `/campaign/${campaignId}`,
      campaign
    );
    return response.data;
  },

  startCampaign: async (campaignId: number): Promise<CampaignStartResponse> => {
    const response = await apiClient.post<CampaignStartResponse>(`/campaign/${campaignId}/start`);
    return response.data;
  },

  stopCampaign: async (campaignId: number): Promise<CampaignStopResponse> => {
    const response = await apiClient.post<CampaignStopResponse>(`/campaign/${campaignId}/stop`);
    return response.data;
  },

  getCampaignLinks: async (campaignId: number): Promise<ResidentLink[]> => {
    const response = await apiClient.get<ResidentLink[]>(`/campaign/${campaignId}/links`);
    return response.data;
  },

  getCampaignResponses: async (campaignId: number): Promise<ResidentResponse[]> => {
    const response = await apiClient.get<ResidentResponse[]>(`/campaign/${campaignId}/responses`);
    return response.data;
  },

  getStats: async (): Promise<CampaignStats> => {
    const response = await apiClient.get<CampaignStats>("/campaign/stats");
    return response.data;
  },

  listCampaigns: async (): Promise<CampaignListItem[]> => {
    const response = await apiClient.get<CampaignListItem[]>("/campaign/");
    return response.data;
  },

  getCampaign: async (campaignId: number): Promise<CampaignListItem> => {
    const response = await apiClient.get<CampaignListItem>(`/campaign/${campaignId}`);
    return response.data;
  },

  deleteCampaign: async (campaignId: number): Promise<void> => {
    await apiClient.delete(`/campaign/${campaignId}`);
  },
};
